<header>
  <div class="warning-icon">
    <mat-icon svgIcon="warning-triangle-outline"/>
  </div>
  <h3>Outdated Connection</h3>
  <fa-icon icon="times" (click)="closeDialog()"/>
</header>

<p>
  Your career and / or academic goals have changed, so this connection is outdated! CPD only wants to connect you with
  the right organizations that can help you achieve your goals, so let us know how you want to proceed.
</p>
<div class="btn-group">
  <button type="button" class="new-connection" (click)="acceptNewConnection()">
    Remove and Select New Connections
  </button>
  <button type="button" class="existing-connection" (click)="acceptPrevConnection()">
    Keep Existing Connections
  </button>
</div>
